module.exports = __webpack_public_path__ + "static/img/1672_phase_function_Paper_Points.173debf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1672_phase_function_Paper_Points.png
// module id = hr0N
// module chunks = 0